import type {
  Bill,
  Deliver,
} from '@backmarket/nuxt-layer-checkout/api/cart/types'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

export function hasCause(err: unknown): err is { cause: unknown } {
  return typeof err === 'object' && err !== null && 'cause' in err
}

export function hasTypeAsCause(
  err: unknown,
): err is { cause: { type: BouyguesAddressType } } {
  return (
    hasCause(err) &&
    typeof err.cause === 'object' &&
    err.cause !== null &&
    'type' in err.cause
  )
}

type NormalizableAddress = Deliver | Bill

type BouyguesAddressType =
  ApiSpecs['/mobile-plan/api/v1/customer-account/address']['POST']['body']['addressType']

/**
 * Normalize and save the address. If there is no error the user can proceed to the next step, without editing the address.
 */
export const useSaveBouyguesAddress = () => {
  const $httpFetch = useHttpFetch()

  const saveBouyguesAddress = async (
    address: NormalizableAddress,
    type: BouyguesAddressType,
  ) => {
    try {
      // TODO [B2CS-273]: Handle API validation errors
      await $httpFetch('/mobile-plan/api/v1/customer-account/address', {
        method: 'POST',
        body: {
          partner: 'BOUYGUES_TELECOM',
          addressType: type,
          country: address.country,
          firstName: address.firstName,
          lastName: address.lastName,
          addressLine1: address.street ?? '',
          addressLine2: address.street2,
          postCode: address.postalCode,
          city: address.city,
        },
      })
    } catch (err) {
      const error = err as Error
      error.cause = { type }

      throw err
    }
  }

  return { saveBouyguesAddress }
}
